import React, {Fragment} from 'react'

// Material-UI Core
import {makeStyles} from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Slide from '@material-ui/core/Slide'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'

// Material-UI Icon
import CloseIcon from '@material-ui/icons/Close'

// Custom Style
import {fullScreenDialogStyle} from '../../styles/jss/components/dialog/fullScreenDialogStyle'


const useStyles = makeStyles(theme => fullScreenDialogStyle(theme))

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />
})

const FullScreenDialog = props => {
	const classes = useStyles()
	const {open, dialogTitle, formContent, button, handleClose} = props

	return (
		<Fragment>
			<Dialog
				fullScreen
				open={open}
				onClose={handleClose}
				TransitionComponent={Transition}
			>
				<AppBar className={classes.appBar}>

					<Toolbar>
						<Typography variant="h6" className={classes.title}>
							{dialogTitle}
						</Typography>

						<div className={classes.root}>
							{button.map((x, key) => {
								return (
									(x.chooseFile)
									?
									<label htmlFor={"full-screen-dialog-btn-" + x.buttonName} key={key}>
										<input
											multiple
											id={"full-screen-dialog-btn-" + x.buttonName}
											type="file"
											style={{display:"none"}}
										/>

										<Button component="span" color="inherit" variant="outlined" size="small">
											{x.buttonName}
										</Button>
									</label>
									:
									<Button component="span" color="inherit" variant="outlined" size="small" key={key} onClick={x.buttonFunction != null ? x.buttonFunction : null}>
										{x.buttonName}
									</Button>
								)
							})}

							<IconButton edge="start" color="inherit" 
								onClick={handleClose} 
								
								aria-label="close" className={classes.toolbarBtn}>
								<CloseIcon />
							</IconButton>
						</div>

					</Toolbar>
				</AppBar>

				<div className={classes.content}>
					{formContent}
				</div>
				
			</Dialog>
		</Fragment>
	)
}


export default FullScreenDialog